import { createValidationSchema, validate } from "@";
import * as yup from "yup";
import type { CreateCampaignFormData } from "../types";

export const schema = createValidationSchema({
  name: validate("req"),
  description: validate("req"),
  template: yup
    .object()
    .shape({
      value: validate("req"),
      label: validate("req"),
    })
    .required("هذا الحقل مطلوب"),
});

export const defaultValues: Partial<CreateCampaignFormData> = {
  // Filter criteria
  specificProjectIds: [],
  specificPhoneNumbers: [],
  excludePhoneNumbers: [],
  template: null,
  minDonationAmount: undefined,
  maxDonationAmount: undefined,
  minAbandonedCartAmount: undefined,
  maxAbandonedCartAmount: undefined,
  hasAbandonedCart: undefined,
  isActive: undefined,
  donationDateFrom: null,
  donationDateTo: null,
  abandonedCartDateFrom: null,
  abandonedCartDateTo: null,
  excludeDonatedFromDate: null,
  excludeDonatedToDate: null,
};
